import React from 'react';
import scaleSize from 'utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 192 192"
    width={scaleSize(192)}
    height={scaleSize(192)}
    fill="none"
  >
    <rect x="32" y="32" width="128" height="128" rx="8" stroke="#9F9F9F" strokeWidth="12" />
    <path d="M64 38V154" stroke="#9F9F9F" strokeWidth="12" />
    <path d="M128 38V154" stroke="#9F9F9F" strokeWidth="12" />
    <path d="M36 96L156 96" stroke="#9F9F9F" strokeWidth="12" />
    <path d="M132 64L156 64" stroke="#9F9F9F" strokeWidth="12" />
    <path d="M132 128H156" stroke="#9F9F9F" strokeWidth="12" />
    <path d="M36 64L60 64" stroke="#9F9F9F" strokeWidth="12" />
    <path d="M36 128H60" stroke="#9F9F9F" strokeWidth="12" />
  </svg>
);
